export default "__VITE_ASSET__oMskMrBE__"